
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53.8 52.804"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"home button","transform":"translate(.5 .5)"}},[_c('rect',{attrs:{"data-name":"[bg]","width":"52.8","height":"51.804","rx":"6","fill":"#fff","stroke":"#d7d7d7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Path 159","d":"M26.518 16.513L15.51 26.226h3.238v9.066h5.18v-6.479h5.182v6.475h5.18v-9.066h3.238z","fill":"#757575","fill-rule":"evenodd"}})])])
          )
        }
      }
    